import { ComponentType, LazyExoticComponent, lazy } from 'react';

export default function<T extends ComponentType<any>>(
  factory: () => Promise<any>, name: string
): LazyExoticComponent<T> {
  return lazy(() => factory().then((module) => ({ default: module[name] })))
}